mobileSize = 800;

$(document).ready(function () {
  // Class for nav items (radius)
  $('.groups .group').each(function () {

    $(this).find('.items > .item').each(function () {
      $(this).addClass('radius-class');

      $(this).find(".subitems > .item").each(function () {
        $(this).addClass(`radius-class`);
      });
    });

    $(this).find('.navClonedItem').removeClass('radius-class')
  });

  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 800) {
    $("body").addClass("saffireMobileSize").removeClass("saffireLargeSize");
  }
  if (windowSize > 801) {
    $("body").removeClass("saffireMobileSize");
  }

  // General Message
  $(".generalmessage").prependTo("header");
  // Custom Email Signup
  $(".homepage .emailSignup .emailSignupText").text("");

  // $(".homepage .emailSignup .emailInputField input").attr(
  //   "value",
  //   "Email Address"
  // );
  $(".homepage .emailSignup .emailSignupText").text("get updates!");
  $(".homepage .emailSignup .emailInputField input").attr(
    "placeholder",
    "Email Address"
  );
  $(".homepage .emailSignup .emailInputField input").val("");

  $(".homepage .emailSignup .emailSubmitButton").text("SUBSCRIBE");

  $(".footer .emailSignup .emailSubmitButton");

  /////////////////////////////////
  $(".getUpdatesPageEmailModule .emailSignup .emailSignupText").text(
    "GET UPDATES!"
  );

  $(".getUpdatesPageEmailModule .emailSignup .emailSubmitButton").text(
    "SUBSCRIBE!"
  );

  $(".getUpdatesPageEmailModule .emailSignup .emailInputField input").attr(
    "placeholder",
    "Email Address"
  );
  ////////////////////////////////

  $("#footer-bottom-container  .modalOnly  .emailSubmitButton").text(
    "SUBSCRIBE"
  );
  $("#footer-bottom-container  .modalOnly  .emailSignupText").text(
    "GET UPDATES!"
  );

  setTimeout(() => {
    let infoBannerContent = $('.countdownDays').text().split(" ")[0]
    if (infoBannerContent === "Thanks") {
      $('#siteInfoBannerWidget ').addClass('hideSeparatorInfoBar')
    } else if (infoBannerContent == "") {
      $('#siteInfoBannerWidget ').addClass('hideSiteInfoBar')
      $('#header-top').addClass('moveCart')
    }
  }, 2000)


});


